import { getChannel, getChannelList, getChannelUpdate } from '@/services/channelApi'
import router from '../router'
const channel = {
  state: () => ({
    chList: { private: [], workspace: [] },
    selectedCh: {
      chType: 'P',
      chId: 'my',
    },
    isChListLoaded: false,
  }),
  mutations: {
    // 선택된 채널 정보 설정
    setSelectedCh(state, selectedCh) {
      state.selectedCh = selectedCh
    },
    // 채널 업데이트 설정
    setChannelUpdate(state, payload) {
      let chType = ''

      if (payload['chType'] === 'I') chType = 'inbox'
      else if (payload['chType'] === 'P') chType = 'private'
      else if (payload['chType'] === 'W') chType = 'workspace'

      let chIndex = state.chList[chType].findIndex((ch) => payload['result']['chId'].indexOf(ch['chId']) > -1)
      if (chIndex > -1) state.chList[chType][chIndex] = Object.assign(state.chList[chType][chIndex], payload['result'])
    },
  },
  actions: {
    async getChannel({ state, dispatch }, chId) {
      let result = await getChannel(this._vm, chId)
      dispatch('setSelectedCh', result)
      state.isChListLoaded = true
    },
    // 채널 목록 조회
    async getChannelList({ state, dispatch }, payload) {
      let result = await getChannelList(this._vm, payload['wsId'])

      // My 채널 가장 앞으로 이동
      let myIdx = result['private'].findIndex((channel) => channel['chCategory'] === 'my')
      if (myIdx > -1) {
        let myChannel = result['private'].splice(myIdx, 1)
        result['private'].unshift(myChannel[0])
      }

      // General 채널 가장 앞으로 이동
      let generalIdx = result['workspace'].findIndex((channel) => channel['chCategory'] === 'general')
      if (generalIdx > -1) {
        let generalChannel = result['workspace'].splice(generalIdx, 1)
        result['workspace'].unshift(generalChannel[0])
      }

      state.chList['private'] = result['private'].map((ch) => Object.assign(ch, { updateCnt: 0 }))
      state.chList['workspace'] = result['workspace'].map((ch) => Object.assign(ch, { updateCnt: 0 }))
      state.chList['inbox'] = result['inbox'].map((ch) => Object.assign(ch, { updateCnt: 0 }))

      state.isChListLoaded = true
      // 현재 채널 저장
      // let routePayload = state.selectedCh,
      //   chType = null,
      //   chId = null,
      //   chIntegrationInfo = ''

      let mergedChList = [...state.chList['private'], ...state.chList['workspace'], ...state.chList['inbox']]

      // // My 로 들어오는 애들은 my Channel 로 replace 시켜줌.
      // if (location.pathname.includes('my')) {
      //   let split = location.pathname.split('/')
      //   let channel = mergedChList.find((ch) => ch.chCategory === 'my')
      //   await router
      //     .replace({
      //       name: 'Channel',
      //       params: { wsDomain: split[1], chId: channel[0]['chId'].replace('CH:', '') },
      //     })
      //     .catch(() => {})
      // }
      let chId =
        router.currentRoute.params['chId'] ??
        (payload && payload['routeParams'] && payload['routeParams']['chId'] ? payload['routeParams']['chId'] : '')
      let wsDomain =
        router.currentRoute.params['wsDomain'] ??
        (payload && payload['routeParams'] && payload['routeParams']['wsDomain']
          ? payload['routeParams']['wsDomain']
          : '')

      // 워크스페이스 생성 후 들어왔을 때
      if (!chId && router.currentRoute.params['passedType'] && router.currentRoute.params['passedType'] === 'invite') {
        chId = result['private'][0]['chId'].replace('CH:', '')
      }
      let mtId
      let pathSplit = location.pathname.split('/')
      if (location.pathname && pathSplit && pathSplit.length > 0) {
        let mtIds = pathSplit.filter((path) => path.includes('MT:'))
        if (mtIds && mtIds.length > 0) mtId = mtIds[0]
      }
      if (chId && result) {
        let channel = []
        if (chId === 'my') {
          channel = mergedChList.filter((ch) => ch.chCategory === 'my')
          await router.replace({
            name: 'Channel',
            params: { wsDomain: wsDomain, chId: channel[0]['chId'].replace('CH:', '') },
          })
        } else if (chId === 'general') {
          channel = mergedChList.filter((ch) => ch.chCategory === 'general')
        } else {
          channel = mergedChList.filter((ch) => ch['chId'].replace('CH:', '') === chId)
          // if (channel.length === 0) {
          //   let myChannel = mergedChList.filter((ch) => ch.chCategory === 'my')
          //   await router.replace({
          //     name: 'Channel',
          //     params: { wsDomain: wsDomain, chId: myChannel.chId },
          //   })
          // }
        }
        if (!channel || channel.length === 0) await dispatch('getChannel', chId)
        else {
          dispatch('setSelectedCh', channel[0])
        }
      }
      // 미팅 Detail 들어갔을 경우 처리
      else if (result && mtId) {
        let channel
        let customList = mergedChList.filter((ch) => ch['mtIdList'] && ch['mtIdList'].length > 0)
        if (customList) {
          channel = customList.find((chList) => chList['mtIdList'].find((mtList) => mtList['mtId'] === mtId))
        } else {
          if (channel) dispatch('setSelectedCh', channel)
        }
      }
      // 채널 업데이트 조회 병렬 처리
      const promises = []

      for (let i = 0; i < mergedChList.length; i++) {
        promises.push(
          this.dispatch('getChannelUpdate', {
            wsId: payload['wsId'],
            chId: mergedChList[i]['chId'],
            chType: mergedChList[i]['chType'],
            chCategory: mergedChList[i]['chCategory'],
          })
        )
      }
      Promise.all(promises)
    },
    // 선택된 채널 정보 설정
    setSelectedCh({ commit, dispatch }, selectedCh) {
      if (selectedCh && selectedCh['chId']) {
        selectedCh['chId'] = selectedCh['chId'].replace('CH:', '')
        commit('setSelectedCh', selectedCh)

        // if (!(selectedCh.isInit ?? false)) {

        if (this.getters.selectedWsInfo && this.getters.selectedWsInfo['wsId']) {
          dispatch('getAssignedCnt', this.getters.selectedWsInfo['wsId'])
          dispatch('getChannelUpdate', {
            wsId: this.getters.selectedWsInfo['wsId'],
            chId: selectedCh['chId'].includes('CH:') ? selectedCh['chId'] : `CH:${selectedCh['chId']}`,
            chType: selectedCh['chType'],
            chCategory: selectedCh['chCategory'],
          })
        }
      } else {
        commit('setSelectedCh', {})
      }
      // }
    },
    // 채널 업데이트 조회
    async getChannelUpdate({ commit }, payload) {
      if (payload && payload['chId'] && !payload['chId'].includes('my')) {
        let result = await getChannelUpdate(this._vm, payload['wsId'], payload['chId'], payload['chCategory'])
        commit('setChannelUpdate', {
          result,
          chType: payload['chCategory'] === 'inbox' ? 'I' : payload['chType'],
        })
      }
    },
  },

  getters: {
    chList(state) {
      return state.chList
    },
    // 선택된 채널 정보
    selectedCh(state) {
      return state.selectedCh
    },
    isChListLoaded(state) {
      return state.isChListLoaded
    },
  },
}

export default channel
